(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-faq"] && !window.DesignMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function () {
        const faqQuestions = document.querySelectorAll('[class^="faq-question-"]');

        faqQuestions.forEach((question) => {
        question.addEventListener('click', function () {
            const answer = this.nextElementSibling;
            const isOpen = this.classList.contains('is-open');

            faqQuestions.forEach((q) => {
            if (q !== question) {
                q.classList.remove('is-open');
                q.nextElementSibling.classList.remove('is-open');
                q.nextElementSibling.style.maxHeight = null;
            }
            });

            this.classList.toggle('is-open');
            answer.classList.toggle('is-open');

            if (!isOpen) {
            answer.style.maxHeight = answer.scrollHeight + 'px';
            } else {
            answer.style.maxHeight = null;
            }
        });
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-navigation"] && !window.DesignMode) return;
  try {
    
  class ScrollNavigation {
    constructor(container) {
      this.container = container;
      this.button = container.querySelector('[data-scroll-nav-button]');
      this.buttonText = container.querySelector('[data-scroll-nav-text]');
      this.popup = container.querySelector('[data-scroll-nav-popup]');
      this.links = container.querySelectorAll('[data-scroll-nav-link]');
      this.percentageElement = container.querySelector('[data-scroll-percentage]');

      if (!this.button || !this.popup || !this.links.length || !this.percentageElement) {
        console.warn('ScrollNavigation: Required elements not found');
        return;
      }

      this.setupEventListeners();
      this.updateScrollPercentage();
      this.updateActiveSection();
    }

    setupEventListeners() {
      // Toggle popup and button text
      this.button?.addEventListener('click', () => {
        const isExpanded = this.button.getAttribute('aria-expanded') === 'true';
        this.button.setAttribute('aria-expanded', !isExpanded);
        this.popup.hidden = isExpanded;
        this.buttonText?.classList.toggle('hidden', !isExpanded);

        if (!isExpanded) {
          this.updateActiveSection();
        }
      });

      // Handle section navigation
      this.links?.forEach((link) => {
        link.addEventListener('click', (e) => {
          const sectionId = e.target.dataset.sectionId;
          const section = document.getElementById(sectionId);

          if (section) {
            section.scrollIntoView({ behavior: 'smooth' });
            this.popup.hidden = true;
            this.button.setAttribute('aria-expanded', 'false');
            this.buttonText?.classList.remove('hidden');
            this.updateActiveSection(sectionId);
          }
        });
      });

      // Update active section on scroll
      const scrollHandler = () => {
        requestAnimationFrame(() => {
          this.updateScrollPercentage();
          this.updateActiveSection();
        });
      };

      window.addEventListener('scroll', scrollHandler, { passive: true });

      // Close popup when clicking outside
      document.addEventListener('click', (e) => {
        if (!this.button?.contains(e.target) && !this.popup?.contains(e.target)) {
          this.popup.hidden = true;
          this.button.setAttribute('aria-expanded', 'false');
          this.buttonText?.classList.remove('hidden');
        }
      });
    }

    updateScrollPercentage() {
      if (!this.percentageElement) return;

      const windowHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const scrolled = window.scrollY;
      const percentage = Math.round((scrolled / windowHeight) * 100);

      this.percentageElement.textContent = `${percentage}%`;
    }

    updateActiveSection(forcedSectionId = null) {
      if (!this.links) return;

      // Remove active class from all links
      this.links.forEach((link) => link.classList.remove('active'));

      if (forcedSectionId) {
        // If a section ID is forced (clicked), set it as active
        const activeLink = Array.from(this.links).find((link) => link.dataset.sectionId === forcedSectionId);
        if (activeLink) {
          activeLink.classList.add('active');
        }
        return;
      }

      // Find the current section based on scroll position
      const sections = Array.from(document.querySelectorAll('[id]')).filter((section) => {
        const sectionId = section.id;
        return Array.from(this.links).some((link) => link.dataset.sectionId === sectionId);
      });

      let currentSection = null;
      const scrollPosition = window.scrollY + 100; // Add offset for better detection

      for (const section of sections) {
        const sectionTop = section.offsetTop;
        const sectionHeight = section.offsetHeight;

        if (scrollPosition >= sectionTop && scrollPosition <= sectionTop + sectionHeight) {
          currentSection = section;
          break;
        }
      }

      if (currentSection) {
        const activeLink = Array.from(this.links).find((link) => link.dataset.sectionId === currentSection.id);
        if (activeLink) {
          activeLink.classList.add('active');
        }
      }
    }
  }

  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    const containers = document.querySelectorAll('[data-scroll-nav]');
    containers.forEach((container) => new ScrollNavigation(container));
  });

  } catch(e) { console.error(e); }
})();
})();
